export const SET_SUM = 'SET_SUM';
export const SET_TABLE = 'SET_TABLE';
export const UNSET_TABLE = 'UNSET_TABLE';

export const CALCULATE_SUM = 'CALCULATE_SUM';
export const SET_CONTRACT = 'SET_CONTRACT';
